<template>
  <v-dialog v-model="dialog" width="720" max-height="696">
    <div class="back-white border-white">
      <v-row
        class="ma-0  align-center text-center justify-center momo-role mb-5 back-556C96"
      >
        <h3 class="color-white ml-5">메모</h3>
      </v-row>
      <v-row calss="ma-0  justify-center d-flex align-center text-center ">
        <v-simple-table v-if="status" class="pa-5" height="500" fixed-header>
          <thead>
            <tr>
              <th
                class="text-center border-top-aaaaaa border-left-aaaaaa border-bottom-aaaaaa back-739eec color-white"
              >
                차수
              </th>
              <th
                class="text-center border-top-aaaaaa border-left-aaaaaa border-bottom-aaaaaa border-right-aaaaaa back-739eec color-white"
              >
                내용
              </th>
            </tr>
          </thead>
          <tbody v-if="orderInvoiceList">
            <tr v-for="list in orderInvoiceList" :key="list.sequencenum">
              <td
                class="text-center border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa"
              >
                {{ list.name }}
              </td>
              <td class="border-right-aaaaaa border-bottom-aaaaaa">
                <v-textarea
                  v-model="list.contents"
                  class="width-500 pa-5 resize-none "
                  solo
                  filled
                  outlined
                  hide-details
                  auto-grow
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-textarea
          v-model="inputData"
          class="width-500 pt-5 pl-5 pr-5 elevation-0"
          solo
          filled
          outlined
          auto-grow
          hide-details
          v-else
        />
      </v-row>
      <v-row class="justify-center mt-5 pb-5">
        <v-btn
          width="150"
          height="40"
          color="#739EEC"
          class="text-color font-size-20"
          @click="restoreText"
          :disabled="viewerRole"
          >변경사항 저장</v-btn
        >
        <v-btn
          width="150"
          height="40"
          color="#eeeeee"
          class=" ml-5 font-size-20"
          @click="dialog = !dialog"
          >닫기
        </v-btn>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import InvoiceApi from "@/api/InvoiceService";
import OrderApi from "@/api/OrderService";
import OrderInvoiceApi from "@/api/OrderInvoiceService";
import CompleteApi from "@/api/CompleteService";

export default {
  data: () => ({
    inputData: "",
    dialog: false,
    list: "",
    status: false,
    orderInvoiceList: [],
    state: "",
  }),

  watch: {
    dialog(state) {
      if (!state) {
        this.inputData = "";
        let status;
        if (this.state == "invoice") status = "invoiceNavigationDuplicated";
        else if (this.state == "order") status = "orderNavigationDuplicated";
        else if (this.state == "orderInvoice")
          status = "orderInvoiceNavigationDuplicated";
        else if (this.state == "complete")
          status = "completeNavigationDuplicated";
        this.$bus.$emit(status);
      }
    },
  },
  computed: {
    viewerRole() {
      return this.$store.getters.getUserList.roleType === "뷰어";
    },
  },
  created() {
    this.$bus.$on("memoOn", async (data, state) => {
      this.memoStart(data, state);
    });
  },

  methods: {
    async memoStart(data, state) {
      this.state = state;
      this.status = false;
      let returnData;
      if (state == "invoice") {
        this.list = { state: "invoice", invoiceId: data };
        returnData = await InvoiceApi.invoiceReadMemo({ invoiceId: data });
        this.inputData = returnData.data.memo ? returnData.data.memo.memo : "";
      } else if (state == "order") {
        this.list = { state: "order", orderId: data };
        returnData = await OrderApi.orderReadMemo({ orderId: data });
        this.inputData = returnData.data.memo ? returnData.data.memo.memo : "";
      } else if (state == "orderInvoice") {
        this.list = { state: "orderInvoice", orderId: data };
        returnData = await OrderInvoiceApi.orderinvoiceMemo({ orderId: data });
        this.orderInvoiceList = returnData.data.memoList;
        this.status = true;
      } else if (state == "complete") {
        this.list = { state: "complete", invoiceId: data };
        returnData = await CompleteApi.completeReadMemo({ invoiceId: data });
        this.inputData = returnData.data.memo ? returnData.data.memo.memo : "";
      }
      this.dialog = true;
    },
    async restoreText() {
      if (this.list.state == "invoice") {
        await InvoiceApi.invoiceWriteMemo({
          memo: this.inputData,
          invoiceId: this.list.invoiceId,
        });
      } else if (this.list.state == "order") {
        await OrderApi.orderWriteMemo({
          memo: this.inputData,
          orderId: this.list.orderId,
        });
      } else if (this.list.state == "orderInvoice") {
        await OrderInvoiceApi.orderinvoiceChangeMemo({
          memo: this.orderInvoiceList,
        });
      } else if (this.list.state == "complete") {
        await CompleteApi.completeWriteMemo({
          memo: this.inputData,
          invoiceId: this.list.invoiceId,
        });
      }
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.back-739eec {
  background: #739eec !important;
}

.font-size-20 {
  font-family: "Noto Sans KR";
  font-size: 20px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0em;
  text-align: center;
}
.momo-role {
  background: #c4c4c4;
  height: 60px;
}
.width-500 {
  width: 600px;
  word-break: break-all;
}
.width-height {
  width: 1000px;
  height: 400px;
  word-break: break-all;
}

.text-color {
  color: white !important;
  font-size: 18px;
}

.row {
  margin: 0px;
}

.v-text-field__details {
  height: 0px !important;
}

.resize-none {
  resize: none;
}

.ml-80 {
  margin-left: 80px;
}

.border {
  border: thin solid gray;
  border-radius: 5px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
}
</style>
